import InvoiceRow from './InvoiceRow.view';

export default InvoiceRow;
